<template>
  <transition name="fade">
    <div class="userModal" v-if="show">
      <div class="overlay"></div>
      <div :class="{modalContent: true, modalBig: true}">
        <div class="content">
          <div class="lifeguard"></div>
          <div class="leafL"></div><div class="leafR"></div>
          <div class="ball"></div><div class="payungB"></div>
          <div class="rumputL"></div><div class="rumputR"></div>
          <div class="tideBg"></div>
          <div class="logoCnt">
            <div class="nutrilite"></div>
            <div class="youthfuel"></div>
          </div>
          <form v-on:submit.prevent="handleSubmit">
            <div class="formHeader">
              <h5>Selamat Datang Di</h5>
              <h4>Youthfuel Summer Festival!</h4>
              <p>Silahkan isi data di bawah ini untuk masuk.</p>
            </div>
            <div class="formContent">
              <div :class="{fieldGroup: true, hasError: form.name.error}">
                <label>Nama Kamu</label>
                <input type="text" placeholder="Nama lengkap..." class="field"
                  v-model="form.name.model">
                <div class="fieldError" v-if="form.name.error">{{form.name.error}}</div>
              </div>
              <div class="fieldGroup">
                <label>Apakah Kamu</label>
                <div class="radioCnt">
                  <li class="radioItem" v-on:click="userType = 'abo'">
                    <div :class="{radio: true, on: userType === 'abo'}">
                      <div class="radioIn"></div>
                    </div>
                    Amway Business Owner
                  </li>
                  <li class="radioItem" v-on:click="userType = 'pp'">
                    <div :class="{radio: true, on: userType === 'pp'}">
                      <div class="radioIn"></div>
                    </div>
                    Pelanggan Prioritas
                  </li>
                  <li class="radioItem" v-on:click="userType = 'umum'">
                    <div :class="{radio: true, on: userType === 'umum'}">
                      <div class="radioIn"></div>
                    </div>
                    Umum
                  </li>
                </div>
              </div>
              <button class="btn rounded orange"
                :class="{btnLoading: loading}" type="submit">
                Simpan &amp; Lanjutkan
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      loading: false,
      form: {
        name: { model: '', error: null },
      },
      userType: 'abo',
      next: null,
    };
  },
  computed: {},
  methods: {
    open(n) {
      this.show = true;
      this.next = n;
    },
    close() {
      this.show = false;
      if (this.next) this.next(this.form.name.model);
    },
    handleSubmit() {
      if (this.loading) return;
      if (!this.form.name.model || this.form.name.model === '' || this.form.name.model === ' ') {
        this.form.name.error = 'Mohon masukan nama kamu.';
        return;
      }
      this.loading = true;
      this.$http.post(this.$config.uri('user/reg'), {
        name: this.form.name.model,
        type: this.userType,
      }).then((response) => {
        if (response.data.status !== 200) {
          // Display error
          return;
        }
        localStorage.setItem('id', response.data.id);
        localStorage.setItem('name', this.form.name.model);
        localStorage.setItem('token', response.data.token);
        this.close();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.userModal{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 40px 0;
  @media (max-width: 680px) {
    padding: 20px 10px;
  }
  .overlay{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
  }
  .modalContent{
    position: relative;
    z-index: 2;
    background: #fff;
    margin: auto;
    border-radius: 5px;
    overflow: hidden;
    transition: all .3s ease;
    background-color: #f6c8c8;
    background-image: url(../assets/main-bg.jpg);
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    .close{
      width: 36px;
      height: 36px;
      border-radius: 50%;
      background-image: url(../assets/close.png);
      background-size: 14px auto;
      background-position: center;
      background-repeat: no-repeat;
      position: absolute;
      right: 10px;
      top: 10px;
      opacity: .4;
      cursor: pointer;
      transition: all .2s linear;
      z-index: 3;
    }
    .close:hover{
      background-color: #e5e5e5;
      opacity: .7;
    }
    .content{
      width: 860px;
      box-sizing: border-box;
      display: flex;
      position: relative;
      z-index: 2;
      @media (max-width: 960px) {
        display: block;
        width: auto;
      }
      .loading{
        position: absolute;
        left: 0; top: 0; right: 0; bottom: 0;
        background-color: #f6c8c8;
        background-image: url(../assets/main-bg.jpg);
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        z-index: 999;
        .loadingImg{
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 0;
          background-image: url(../assets/loading.svg);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 46px auto;
        }
      }
      .cloudBig, .pear, .pineaple, .colagen{
        position: absolute;
      }
      .logoCnt{
        width: 40%;
        padding: 100px 0;
        z-index: 9;
        @media (max-width: 960px) {
          padding: 0; width: auto;
          display: none;
        }
        .nutrilite{
          width: 140px; height: 20px;
          margin: 0 auto -20px;
          background-image: url(../assets/nutrilite.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: contain;
          @media (max-width: 960px) {
            display: none;
          }
        }
        .youthfuel{
          width: 280px; height: 340px;
          background-image: url(../assets/logo.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          margin: 0 auto;
          @media (max-width: 960px) {
            position: absolute;
            top: -100px; left: 50%;
          }
        }
      }
      form{
        width: 60%;
        padding: 60px 40px;
        box-sizing: border-box;
        position: relative;
        z-index: 9;
        @media (max-width: 960px) {
          width: auto;
          padding: 40px 20px 30px;
        }
        .formHeader{
          text-align: center;
          padding-top: 10px;
          @media (max-width: 960px) {
            // padding-top: 0;
          }
          h5{
            font-family: CarlaSansBold;
            font-size: 16px;
            margin: 0 0 10px;
            @media (max-width: 960px) {
              font-size: 15px;
              margin-bottom: 4px;
            }
          }
          h4{
            font-family: CarlaSansBold;
            font-size: 20px;
            margin: 0 0 6px;
            @media (max-width: 960px) {
              margin-bottom: 0;
            }
          }
          p{
            margin: 0;
            font-weight: normal;
            @media (max-width: 960px) {
              font-size: 13px;
            }
          }
        }
        .formContent{
          max-width: 320px;
          margin: 0 auto;
          padding: 30px 0 16px;
          box-sizing: border-box;
          .fieldGroup{
            .field{
              border: none;
              @media (max-width: 960px) {
                margin-left: 0;
              }
            }
          }
          .btn{
            @media (max-width: 960px) {
              width: 100%;
            }
          }
        }
      }
    }
  }
}

.lifeguard{
  width: 120px; height: 120px;
  background-image: url(../assets/q1.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  position: absolute;
  left: 360px; top: -64px;
}
.leafL{
  width: 280px; height: 280px;
  position: absolute;
  left: -100px; top: -96px;
  background-image: url(../assets/leaf-l2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 8;
}
.leafR{
  width: 280px; height: 280px;
  position: absolute;
  right: -100px; top: -96px;
  background-image: url(../assets/leaf-r2.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 8;
}
.rumputL{
  width: 160px; height: 300px;
  position: absolute;
  left: -60px; bottom: -140px;
  background-image: url(../assets/rumput-l.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;
}
.rumputR{
  width: 160px; height: 300px;
  position: absolute;
  right: -60px; bottom: -180px;
  background-image: url(../assets/rumput-r.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  animation: windAn 10s infinite ease;
  z-index: 8;
}
.payungB{
  width: 180px; height: 180px;
  position: absolute;
  left: 220px; bottom: -140px;
  background-image: url(../assets/umbrela-pink.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 7;
}
.ball{
  width: 80px; height: 80px;
  position: absolute;
  right: -30px; bottom: 160px;
  background-image: url(../assets/bola-pantai.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 4;
}
.tideBg{
  background-image: url(../assets/tide-bg.png);
  background-size: cover;
  background-position: bottom center;
  background-repeat: no-repeat;
  position: absolute;
  left: 0; right: 0; top: 0;
  height: 150px;
  z-index: 1;
}
</style>
